module.exports = __webpack_public_path__ + "static/media/cara-bg-main.78cb131a.png";